import React, {Component} from 'react';
import './PhoneNumberConfirmModal.css';

class PhoneNumberConfirmModal extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {};

    render() {
        return (
            <div className="modal fade" id="confirm-phone-number" tabIndex="-1">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal">×</button>
                            <h4 className="modal-title">Подтверждение номера телефона</h4>
                        </div>
                        <div className="modal-body">
                            <form className="form-inline">
                                <p>На ваш номер телефона <strong>+79097449090</strong> было отправлено SMS сообщение с кодом. Пожалуйста, введите его в поле ниже и нажмите на кнопку подтвердить:</p>
                                <input type="text" className="form-control" placeholder="Код"
                                       data-here="masked" data-mask="9999"/>
                                <br />
                                <small className="text-muted">Выслать новый код повторно можно будет через 2:00</small>
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-info pull-left" disabled>Выслать код повторно</button>
                            <button type="button" className="btn" data-dismiss="modal">Отмена</button>
                            <button type="button" className="btn btn-primary" data-dismiss="modal">Подтвердить</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PhoneNumberConfirmModal;


// WEBPACK FOOTER //
// ./src/pages/Profile/modals/PhoneNumberConfirm/PhoneNumberConfirmModal.js